<template lang="html">
    <div class="welcome-video">
        <div class="container">
            <el-row :gutter="24">
                <el-col :sm="24" :md="8">
                    <div class="video-description">
                        <h2 class="video-title" v-html="title"></h2>
                        <div class="description" v-html="description"></div>
                    </div>
                </el-col>
                <el-col :sm="24" :md="16">
                    <div class="video-wrapper">
                        <youtube
                            :video-id="youtube"
                            :mute="true"
                            :player-width="600"
                            :player-height="300"
                        ></youtube>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        youtube: {
            type: String,
            required: false
        }
    },
};
</script>

<style lang="less">
@import '../../less/variables';
.welcome-video {
    background: @color-1;
    padding: 40px 0;
    color: white;
    text-align: center;
    @media @desktop {
        text-align: left;
    }
    .container {
        display: flex;
        flex-direction: column;
        .description {
            margin: 20px 0;
        }
    }
    .video-title {
        color: white;
        text-transform: uppercase;
    }
    iframe {
        height: 320px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/welcome-video.vue